export const jewelTypeMap = {
  1: {
    urlSlugKey: 'ringen',
    title: {
      en: 'Rings',
      nl: 'Ringen',
    },
  },
  2: {
    urlSlugKey: 'armbanden',
    title: {
      en: 'Bracelets',
      nl: 'Armbanden',
    },
  },
  3: {
    urlSlugKey: 'oorbellen',
    title: {
      en: 'Earrings',
      nl: 'Oorbellen',
    },
  },
  4: {
    urlSlugKey: 'colliers',
    title: {
      en: 'Colliers',
      nl: 'Colliers',
    },
  },
  7: {
    urlSlugKey: 'hangers',
    title: {
      en: 'Pendants',
      nl: 'Hangers',
    },
  },
}
